import VolumeTiersRow from './elements/VolumenTiersRow';
import RulesPanel from '../../../../../common/rulesPanel/RulesPanel';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import { Alert, AlertTones } from '@clockout-dev/design-elements';
import styles from '../../styles/feeStructureForm.module.scss';

/**
 * Dumb sub-tab view. Receives the bundle from
 * `VolumeTiersPanelController.getViewProps()` — `orderedRules`,
 * `conflictIds`, `errorMessage`, the `onAdd` / `onRemove` / `onUpdate`
 * mutators owned by the parent FeeStructureController, and the local
 * `onCommitOrder` from the sub-controller.
 */
function VolumeTiersPanel({
    orderedRules = [],
    conflictIds = new Set(),
    errorMessage,
    onAdd,
    onRemove,
    onUpdate,
    onCommitOrder
}) {
    return (
        <div className={styles.panel}>
            <Alert
                tone={AlertTones.WARNING}
                content="If an amount falls out of the segmentation the fee will be derived from your Instant Advance Fee configuration"
            />
            <RulesPanel
                onAdd={onAdd}
                addLabel="Add a threshold setting row"
                errorMessage={errorMessage}
                emptyState={
                    <EmptyState
                        title="No volume thresholds yet"
                        description="Add a row to charge a different fee per advance amount range."
                    />
                }
                classNames={{ root: styles.volumenTierPanel }}
            >
                {orderedRules.map((rule) => (
                    <VolumeTiersRow
                        key={rule.id}
                        id={rule.id}
                        from={rule.fromAmount}
                        to={rule.toAmount}
                        fee={rule.fee}
                        commitOrder={onCommitOrder}
                        conflictIds={conflictIds}
                        onRemove={onRemove}
                        onUpdate={onUpdate}
                    />
                ))}
            </RulesPanel>
        </div>
    );
}

export default VolumeTiersPanel;
